import { render, staticRenderFns } from "./HowToPitchUsJP.vue?vue&type=template&id=6d262c6f"
import script from "./HowToPitchUsJP.vue?vue&type=script&lang=js"
export * from "./HowToPitchUsJP.vue?vue&type=script&lang=js"
import style0 from "./HowToPitchUsJP.vue?vue&type=style&index=0&id=6d262c6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports